module.exports = __webpack_public_path__ + "img/nav_group_green.efbfb492.png";